<div class="w-svh h-svh">
  <app-aquila-sidebar></app-aquila-sidebar>

  <div class="fixed left-0 top-0 z-10 h-svh w-svw overflow-hidden">
    <!-- Main container here -->
    <!-- <div class="row-span-12 mx-12 mb-4 mt-12 h-5/6 w-5/6 overflow-hidden"> -->
    <router-outlet></router-outlet>
    <!-- </div> -->
  </div>
</div>
